import React, { useEffect, useState } from 'react';
import { UnitsOfMeasurementImage } from '../../../../assets/images';
import AddEditUnitOfMeasurementModal from '../../../../components/ClientSettings/StockManager/UnitsOfMeasurement/AddEditUnitOfMeasurementModal';
import { CommonHeader, Loader, EmptyListPage, ErrorSuccessModal } from '../../../../components/commons';
import { connect } from "react-redux"
import { RootState } from '../../../../redux/rootReducers';
import { AddUnitMeasurementListPayloadType, GetAllUnitMeasurementListPayloadType, UpdateUnitsMeasermentPayloadType } from '../../../../commonTypes/clientSettingsTypes';
import { addUnitMeasurementListAction, getAllUnitMeasurementListAction, resetAllUnitsMeasurmentList, resetClientSettingsError, resetClientSettingsSuccess, resetUnitsMeasurementListTotal, updateUnitsMeasermentAction } from '../../../../redux/clientSettings';
import { AllUnitsMeasurementListType, SelectOptionType, UnitOfMeasurementDataType } from '../../../../redux/clientSettings/clientSettingTypes';
import { UNITS_MEASURMENT_HEADER } from '../../../../constant/tableHeadersConstants/clientSettingsconstants/unitsMeasurmentList';
import { resetSession } from '../../../../redux/auth';
import UnitsMesurnmentListTable from '../../../../components/ClientSettings/StockManager/UnitsOfMeasurement/UnitsMeasurmentTable/UnitsMesurnmentListTable';
import toast, { Toaster } from 'react-hot-toast';
import { useMenuCheck } from '../../../../customHooks/useMenuCheck';

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  totalCount: number;
  allUnitsMeasurement: [] | AllUnitsMeasurementListType[];
  dispatchGetAllUnitMeasurementListAction: (data: GetAllUnitMeasurementListPayloadType) => void;
  dispatchAddUnitMeasurementListAction: (data: AddUnitMeasurementListPayloadType) => void;
  dispatchUpdateUnitsMeasermentAction: (data: UpdateUnitsMeasermentPayloadType) => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchResetAllUnitsMeasurmentList: () => void;
  dispatchResetUnitsMeasurementListTotal: () => void;
}

const UnitsOfMeasurement = ({
  history,
  token,
  success,
  fetching,
  error,
  statusCode,
  totalCount,
  allUnitsMeasurement,
  dispatchGetAllUnitMeasurementListAction,
  dispatchAddUnitMeasurementListAction,
  dispatchResetClientSettingsError,
  dispatchResetSession,
  dispatchResetClientSettingsSuccessAction,
  dispatchResetAllUnitsMeasurmentList,
  dispatchUpdateUnitsMeasermentAction,
  dispatchResetUnitsMeasurementListTotal
}: AppProps) => {

  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [showAddUnitOfMeasurementModal, setShowAddUnitOfMeasurementModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editUnitsMeasermentData, setEditUnitsMeasermentData] = useState<any>({});
  const [successMessage, setSuccessMessage] = useState<string>("");


  //====================User Management=============================
  const [isAddUnitOfMeasurementPresent, setIsAddUnitOfMeasurementPresent] = useMenuCheck()
  const [isEditUnitOfMeasurementPresent, setIsEditUnitOfMeasurementPresent] = useMenuCheck()
  //=================================================================

  const [unitOfMeasurementData, setUnitOfMeasurementData] = useState<UnitOfMeasurementDataType>({
    symbol: '',
    formalName: '',
    uqc: '',
    numOfDecimalPlaces: 0
  });

  const [uniqueQuantityCode, setUniqueQuantityCode] = useState<SelectOptionType>({
    value: '',
    label: 'Select Unique Quantity Code...'
  })


  const toggleAddEditUnitOfMeasurementModal = () => {
    setShowAddUnitOfMeasurementModal(!showAddUnitOfMeasurementModal);
    setIsEdit(false)
    setUnitOfMeasurementData(() => ({
      symbol: '',
      formalName: '',
      uqc: '',
      numOfDecimalPlaces: 0
    }))
    setUniqueQuantityCode(() => ({
      value: '',
      label: 'Select Unique Quantity Code...'
    }))
  }

  useEffect(() => {
    dispatchResetClientSettingsError();
    dispatchResetClientSettingsSuccessAction();
    dispatchResetAllUnitsMeasurmentList();
    dispatchResetUnitsMeasurementListTotal();
    setEditUnitsMeasermentData({})
    if (token && client_code) {
      const finalData = {
        token, client_code
      }
      dispatchGetAllUnitMeasurementListAction(finalData);
      setIsAddUnitOfMeasurementPresent("Add Unit Of Measurement", "menu")
      setIsEditUnitOfMeasurementPresent("Edit Unit Of Measurement", "menu")
    }
    //eslint-disable-next-line
  }, [])

  const handleAddUnitsMeasurment = (data: AddUnitMeasurementListPayloadType) => {
    if (token && client_code) {
      let finalData = {
        ...data,
        token,
        client_code,
      }

      dispatchAddUnitMeasurementListAction(finalData)
      setShowAddUnitOfMeasurementModal(false)
      handleSuccessMessage("create_units")
    }

  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      dispatchResetClientSettingsSuccessAction();
      toast.success(successMessage, {
        duration: 2000,
      });

      if (token && client_code) {
        let finalData = {
          token,
          client_code,
        };
        dispatchGetAllUnitMeasurementListAction(finalData);
      }
    }

    return false;
  };

  const handleSendUnitsmeasermentModal = (data: AllUnitsMeasurementListType) => {
    setIsEdit(true)
    setShowAddUnitOfMeasurementModal(true)
    setEditUnitsMeasermentData(data)
  }

  const handleResetEditData = () => {
    setIsEdit(false);
    setEditUnitsMeasermentData({});
  }

  const handleEditUnitsMeasermentDetails = (data: UpdateUnitsMeasermentPayloadType) => {
    setShowAddUnitOfMeasurementModal(false);
    let finalData = {
      token,
      client_code: client_code,
      stockUnitId: data?.stockUnitId,
      stockUnitName: data?.stockUnitName,
      stockUnitSymbol: data?.stockUnitSymbol,
      numOfDecimalPlaces: data?.numOfDecimalPlaces,
      uniqueQuantityCode: {
        value: data?.uniqueQuantityCode?.value,
        label: data?.uniqueQuantityCode?.label
      }

    }
    if (token && client_code) {
      setIsEdit(false)
      dispatchUpdateUnitsMeasermentAction(finalData)
      handleSuccessMessage("update_units")
    }
  }

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "update_units":
        return setSuccessMessage("Units Measurement Updated Successfully!");
      case "create_units":
        return setSuccessMessage("Units Details Added Successfully!");
      default:
        return setSuccessMessage("Document Created Successfully!");
    }
  };

  return (
    <div className='row'>
      <div className="col-md-6">
        <CommonHeader
          title='Units of Measurement'
          company_name={company_name}
          client_code={client_code}

        />
      </div>
      <div className='col-md-6 text-right'>
        {allUnitsMeasurement?.length && isAddUnitOfMeasurementPresent ? (
          <button className="btn btn-primary" onClick={toggleAddEditUnitOfMeasurementModal}>
            + Add Unit of Measurement
          </button>
        ) : null}
      </div>
      {fetching && <Loader />}
      <div className='col-md-12 mt-4'>
        <div className='new-table-card'>
          <div className='header'>
            <div className="left-header">
              <div className="heading">Unit of Measurement List</div>
              {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${totalCount ? totalCount : 0
                } entries found`}</div>}
            </div>
          </div>
          {fetching ? null : allUnitsMeasurement?.length ? (
            <UnitsMesurnmentListTable
              fetching={fetching}
              data={allUnitsMeasurement}
              headers={UNITS_MEASURMENT_HEADER}
              handleEditUnitsMeasurmentDetails={handleSendUnitsmeasermentModal}
              isEditUnitOfMeasurementPresent={isEditUnitOfMeasurementPresent}
            />
          ) : (
            <EmptyListPage
              title='No Units Of Measurement Found!'
              text='Add a unit of measurement to see it here in the list!'
              image={UnitsOfMeasurementImage}
              imageWidth="30%"
              showAddButton
              buttonTitle='+ Add Unit of Measurement'
              onButtonClick={toggleAddEditUnitOfMeasurementModal}
            />
          )
          }
        </div>
      </div>
      {
        showAddUnitOfMeasurementModal && <AddEditUnitOfMeasurementModal
          isOpen={showAddUnitOfMeasurementModal}
          toggleAddEditUnitOfMeasurementModal={toggleAddEditUnitOfMeasurementModal}
          unitOfMeasurementData={unitOfMeasurementData}
          uniqueQuantityCode={uniqueQuantityCode}
          setUnitOfMeasurementData={setUnitOfMeasurementData}
          setUniqueQuantityCode={setUniqueQuantityCode}
          client_code={client_code}
          handleAddUnitsMeasurment={handleAddUnitsMeasurment}
          isEdit={isEdit}
          editAccountDetailsData={editUnitsMeasermentData}
          handleResetEditData={handleResetEditData}
          handleEditUnitsMeasermentDetails={handleEditUnitsMeasermentDetails}
        />
      }
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </div>
  )
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientSettings.fetching,
  success: state.clientSettings.success,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  allUnitsMeasurement: state.clientSettings.allUnitsMeasurement,
  totalCount: state.clientSettings.unitsMeasurementListTotal
})

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () => dispatch(resetClientSettingsSuccess()),
  dispatchResetAllUnitsMeasurmentList: () => dispatch(resetAllUnitsMeasurmentList()),
  dispatchGetAllUnitMeasurementListAction: (data: GetAllUnitMeasurementListPayloadType) =>
    dispatch(getAllUnitMeasurementListAction(data)),
  dispatchAddUnitMeasurementListAction: (data: AddUnitMeasurementListPayloadType) => dispatch(addUnitMeasurementListAction(data)),
  dispatchUpdateUnitsMeasermentAction: (data: UpdateUnitsMeasermentPayloadType) => dispatch(updateUnitsMeasermentAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetUnitsMeasurementListTotal: () => dispatch(resetUnitsMeasurementListTotal())
});

export default connect(mapStateTopProps, mapDispatchToProps)(UnitsOfMeasurement);